// Covers the checkout while a payment is in flight. Otherwise the packets, the consent checkbox,
// the email and the pay button stay live under a charge that is already on its way: a buyer can
// switch packets in the seconds before 3-D Secure and be asked to approve the old amount, or
// untick the consent box after paying.
//
// #app is made inert as well, so the keyboard cannot reach what the overlay covers. The 3-D Secure
// screens are mounted on <body>, outside #app and above this layer — Stripe's frame at z-index
// 2147483647, Yuno's modal at 2000 — so a challenge stays usable. PayPal is a full-page redirect.
//
// Both checkout layouts load different stylesheets, so the overlay brings its own.

const STYLE = `
.checkout-lock {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /* Above the page and its header, below both 3-D Secure screens. */
    z-index: 1500;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.6);
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    visibility: hidden;
    opacity: 0;
}
.checkout-lock.is-active {
    visibility: visible;
    opacity: 1;
    /* Blocks at once; fades in late enough that a form error answered in a moment does not flash. */
    transition: opacity 0.2s ease 0.1s;
}
.checkout-lock__spinner {
    width: 48px;
    height: 48px;
    border: 4px solid rgba(var(--brand-rgb, 0, 132, 255), 0.2);
    border-top-color: var(--brand, #0084FF);
    border-radius: 50%;
    animation: checkout-lock-spin 0.9s linear infinite;
}
.checkout-lock__text {
    margin: 16px 0 0;
    padding: 0 16px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    text-align: center;
}
@keyframes checkout-lock-spin {
    to { transform: rotate(360deg); }
}
`;

let overlay = null;

function createOverlay() {
    const style = document.createElement('style');
    style.textContent = STYLE;
    document.head.appendChild(style);

    const el = document.createElement('div');
    el.className = 'checkout-lock';
    el.setAttribute('role', 'status');
    el.innerHTML = '<span class="checkout-lock__spinner" aria-hidden="true"></span>'
        + '<p class="checkout-lock__text">Processing your payment…</p>';
    document.body.appendChild(el);

    return el;
}

function setCheckoutLocked(locked) {
    if (!overlay) {
        if (!locked) return;
        overlay = createOverlay();
    }
    overlay.classList.toggle('is-active', locked);

    const app = document.getElementById('app');
    if (app) app.toggleAttribute('inert', locked);
}

export {
    setCheckoutLocked,
}
